import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getKpiConfig } from '../requests/api';

const getData = (res) => res?.data ?? res;

export const loadKpiConfig = createAsyncThunk(
	'kpiConfig/load',
	async (_, { rejectWithValue }) => {
		try { return getData(await getKpiConfig()); }
		catch (e) { return rejectWithValue(e.response?.data ?? e.message); }
	}
);

const kpiConfigSlice = createSlice({
	name: 'kpiConfig',
	initialState: { items: [], loading: false, error: null },
	reducers: {},
	extraReducers: b => {
		b.addCase(loadKpiConfig.pending,   s => { s.loading = true;  s.error = null; })
			.addCase(loadKpiConfig.fulfilled, (s, a) => { s.loading = false; s.items = a.payload; })
			.addCase(loadKpiConfig.rejected,  (s, a) => { s.loading = false; s.error = a.payload; });
	},
});

export default kpiConfigSlice.reducer;

export const selectKpiNamesByTech = tech => state =>
	state.kpiConfig.items
		.filter(k => k.tech === tech)
		.map(k => k.kpiName);

// Returns unique categories for a tech, sorted
export const selectCategoriesByTech = tech => state =>
	[...new Set(
		state.kpiConfig.items
			.filter(k => k.tech === tech)
			.map(k => k.category)
	)].sort();

// Returns KPI names grouped by category for a tech
// { 'Performance': ['SERVICE DR', ...], 'Capacity': [...], ... }
export const selectKpisByTechGrouped = tech => state => {
	const items = state.kpiConfig.items.filter(k => k.tech === tech);
	return items.reduce((acc, k) => {
		if (!acc[k.category]) acc[k.category] = [];
		acc[k.category].push(k.kpiName);
		return acc;
	}, {});
};